import React from "react";
import Form from "../../componet/Form";
import Slider from "../../componet/Slider";
import Orientation from "../../componet/Orientation";
import PreSale from "../../componet/PreSale";
import ForeCasts from "../../componet/ForeCasts";
import {
  Container,
  ContainerIcon,
  ContainerText,
  ContainerIconText,
  Text,
  IconContainer,
} from "./styled";
import Moderno from "../../img/Modern";
import Adaptable from "../../img/Adaptable";
import OpenIcon from "../../img/OpenIcon";
import Menu from "../../componet/Menu/index";
import { useScroll } from "../../context/UseContextScroll";
import { useTranslation } from "react-i18next";

const Home = ({ openMenu, setOpenMenu }) => {
  const [t, i18n] = useTranslation("global");
  const lenguageCss = i18n.languages[0];

  const { scroll } = useScroll();

  const arrayHome = [
    {
      id: 1,
      icon: Moderno,
      title: t("titleModern.titleModern"),
      text: t("moderno.moderno"),
    },
    {
      id: 2,
      icon: Adaptable,
      title: t("titleAdaptable.titleAdaptable"),
      text: t("adaptable.adaptable"),
    },
    {
      id: 3,
      icon: OpenIcon,
      title: t("titleOpen.titleOpen"),
      text: t("OpenInfo.OpenInfo"),
    },
  ];

  return (
    <>
      <Menu openMenu={openMenu} setOpenMenu={setOpenMenu} />
      <ContainerIconText id="feature">
        {arrayHome.map((item) => (
          <ContainerIcon key={item.id}>
            <IconContainer>
              <item.icon />
            </IconContainer>
            <ContainerText
              Text
              scroll={scroll}
              lenguageCss={lenguageCss}
              text={item.id}
            >
              <h4>{item.title}</h4>
              <Text scroll={scroll}>{item.text}</Text>
            </ContainerText>
          </ContainerIcon>
        ))}
      </ContainerIconText>
      <ForeCasts />
      <Container></Container>
      <PreSale />
      <Orientation />
      <Slider />
      <Form />
    </>
  );
};

export default Home;
